module.exports = __webpack_public_path__ + "img/webBxd_thumb.e4af6702.png";